const BAIDU_CODE =
  process.env.NODE_ENV === 'production'
    ? '3ae706ab77147e00a5e1c33f10211159'
    : '6b2179313c99776c0c0778532ee8cb51';

let script = document.createElement('script');
script.innerHTML = `
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?${BAIDU_CODE}';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})();
`;
document.getElementsByTagName('head')[0].appendChild(script);



// WEBPACK FOOTER //
// ./src/utils/hm.js